var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D2445;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,5V2h12v3H18z M22.5,27.4h3V15.9h-3V27.4z M24,44c-2.5,0-4.8-0.5-7-1.4s-4.1-2.2-5.7-3.9 c-1.6-1.6-2.9-3.5-3.9-5.7c-1-2.2-1.4-4.5-1.4-7c0-2.5,0.5-4.8,1.4-7s2.2-4.1,3.9-5.7s3.5-2.9,5.7-3.9s4.5-1.4,7-1.4 c2.2,0,4.3,0.4,6.3,1.1s3.7,1.8,5.2,3.1l2.5-2.6l2.1,2.1l-2.5,2.6c1.2,1.3,2.2,2.9,3.1,4.8c0.9,1.9,1.3,4.2,1.3,6.8 c0,2.5-0.5,4.8-1.4,7c-1,2.2-2.2,4.1-3.9,5.7c-1.6,1.6-3.5,2.9-5.7,3.9S26.5,44,24,44z M24,41c4.2,0,7.7-1.5,10.6-4.4 C37.5,33.7,39,30.1,39,26s-1.5-7.7-4.4-10.6S28.2,11,24,10.9c-4.2,0-7.7,1.5-10.6,4.4S9,21.8,9,26s1.5,7.7,4.4,10.6 C16.3,39.5,19.8,41,24,41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.63e44122a8214c1018e90f6c0943c719.svg";
export { ForwardRef as ReactComponent };